import React, { useContext, useState } from "react";
import Lead from "../../shared/Lead";
import OrderDocumentVerifiedCheckbox from "../../shared/OrderDocumentVerifiedCheckbox";
import CprCompleted from "../task/cpr/CprCompleted";
import Extension from "../task/cpr/Extension";
import { Settings } from "../../helpers/Contexts";
import * as CONST from "../../helpers/Constants";

const CprResponseForm = ({ task, isCompleted }) => {
  const settings = useContext(Settings);
  const [submitting, setSubmitting] = useState(false);

  //completed, :not_completed, :unable_to_verify, :cpr_still_required

  const [selected, setSelected] = useState({
    required: false,
    notRequired: false,
    notCompleted: false,
    unableToVerify: false,
    completed:
      task.cpr.completed_on_date ||
      task.cpr.sub_status == CONST.CPR.RESULTS_PENDING ||
      task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED
        ? true
        : false,
  });
  const [optionValue, setOptionValue] = useState();
const [subStatusId, setSubStatusId] = useState("");

  const onSubmit = () => {
    let req = {
      id: task.id,
      status: "closed",
      priority: null,
      assigner_id: settings.me.id,
    };

    if (selected.notRequired) {
      task.formHandler({
        task: {
          ...req,
          sub_status_list_id: subStatusId,
          response_attributes: {
            outcome_set_by_id: settings.me.id,
            outcome: "cpr_not_required",
            id: task.response.id,
          },
        },
      });
    }
    if (selected.unableToVerify || selected.notCompleted) {
      task.formHandler({
        task: {
          id: task.id,
          ...req,
          in_review: true,
          event: 'cpr_not_completed',
          response_attributes: {
            outcome_set_by_id: settings.me.id,
            id: task.response.id,
            outcome: selected.unableToVerify ? "unable_to_verify" : "not_completed",
          },
        },
      });
    }
  };

  return (
    <div className="p1">
      <Lead message={task.label} />
      <br />
      <br />

      {task.response.outcome != null && (
        <>
          <b>CPR STATUS</b>
          <br />
          Status: <b>{task.cpr.status} </b>
          <br />
          Substatus:{" "}
          <b>
            <i>{task.cpr.sub_status}</i>
          </b>
          <br />
          Outcome: <b>{task.response.outcome}</b>
          <br />
          Outcome Set By: <b>{task.response.outcome_set_by}</b>
          <br />
          Outcome Set At: <b>{task.response.outcome_set_at}</b>
          <br />
          Acknowledged? <b>{task.response.acknowledged == true ? 'Yes' : 'No'}</b>
          <br />
          Acknowledged At: <b>{task.response.acknowledged_at }</b>

          {task.cpr.order_document && task.cpr.order_document.url && (
            <>
              <br />
              Order Document: <b><a href={task.cpr.order_document.url}>Click to view order document</a></b>
              <br />
              <OrderDocumentVerifiedCheckbox
                task={task}
                settings={settings}
              />
            </>
          )}

          <br />
        </>
      )}
      <br />
      {(task.status == "open" || task.status == "pending") && (
        <>
          {" "}
          <b>Select the option that best describes the patient’s updated CPR status</b>
          <br />
          <select
            className="cpr-form"
            value={optionValue}
            onChange={(e) => {
              setOptionValue(e.target.value);
              e.target.value == "completed"
                ? setSelected({
                    required: false,
                    notRequired: false,
                    unableToVerify: false,
                    completed: true,
                    notCompleted: false,
                  })
                : e.target.value == "required"
                ? setSelected({
                    required: true,
                    notRequired: false,
                    unableToVerify: false,
                    completed: false,
                    notCompleted: false,
                  })
                : e.target.value == "unableToVerify"
                ? setSelected({
                    required: false,
                    notRequired: false,
                    unableToVerify: true,
                    completed: false,
                    notCompleted: false,
                  })
                : e.target.value == "not required"
                ? setSelected({
                    required: false,
                    notRequired: true,
                    unableToVerify: false,
                    completed: false,
                    notCompleted: false,
                  })
                : setSelected({
                    required: false,
                    notRequired: false,
                    unableToVerify: false,
                    completed: false,
                    notCompleted: true,
                  });
            }}
          >
            {!optionValue && <option value="">Is this CPR still required ?</option>}
            <option value={"completed"}>{"CPR completed"}</option>
            {settings.me.support_agent_type == "Admin" && (
              <option value={"required"}>{"CPR still required"}</option>
            )}
            <option value={"not completed"}>{"CPR not completed"}</option>
            <option value={"not required"}>{"CPR not required"}</option>
            <option value={"unableToVerify"}>{"Unable to verify CPR completion"}</option>
          </select>
          {selected.required && (
            <Extension
              data={{
                ...task.cpr,
                ooa: task.patient.out_of_area,
                responseId: task.response.id,
                formHandler: task.formHandler,
                id: task.id,
              }}
            />
          )}
          {selected.notRequired && (
            <>
              <br />
              <br />
              <b>Tell us why</b>

              <br />
              <select
                className="cpr-form"
                onChange={(e) => {
                  setSubStatusId(e.target.value);
                }}
              >
                <option value="">Select an option</option>
                {settings.cpr_status_options.map((i) => (
                  <option key={i.value} value={i.id}>
                    {i.label}
                  </option>
                ))}
              </select>

              <button
                className="check"
                disabled={submitting}
                type="submit"
                onClick={(e) => {
                  setSubmitting(true);
                  onSubmit();
                }}
              >
                Submit
              </button>
            </>
          )}
        </>
      )}
      {(selected.unableToVerify || selected.notCompleted) && (
        <button
          className="check"
          disabled={submitting}
          type="submit"
          onClick={(e) => {
            setSubmitting(true);
            onSubmit();
          }}
        >
          Submit & Close Task
        </button>
      )}
      <br />
      <br />

      {selected.completed && (
        <CprCompleted
          isCompleted={isCompleted}
          task={{
            ...task,
          }}
        />
      )}
    </div>
  );
};

export default CprResponseForm;
